/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Splits_AddInputs */

const cs_deal_splits_add = /** @type {(inputs: Deal_Splits_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat podíl`)
};

const en_deal_splits_add = /** @type {(inputs: Deal_Splits_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add split`)
};

/**
* | output |
* | --- |
* | "Add split" |
*
* @param {Deal_Splits_AddInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_add = /** @type {((inputs?: Deal_Splits_AddInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_AddInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_add(inputs)
	return cs_deal_splits_add(inputs)
});